/**
 * BrandProvider - provides brand context for the dashboard.
 */

import type { ReactNode } from 'react'
import { BrandContext } from './brand-context.js'
import { useBrandSwitcher } from './useBrandSwitcher.js'

interface BrandProviderProps {
  children: ReactNode
}

export function BrandProvider({ children }: BrandProviderProps) {
  const brandState = useBrandSwitcher()
  return <BrandContext.Provider value={brandState}>{children}</BrandContext.Provider>
}
